var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-scroll"},[_vm._t("default"),_c('div',[(_vm.shouldHandle)?_c('button',{staticClass:"btn btn-info btn-block",attrs:{"disabled":_vm.loadingMore},domProps:{"textContent":_vm._s(_vm.buttonText)},on:{"click":_vm.showMore}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }